export function getLocation(store, router, name, params) {
  // 未ログイン
  if (!store.getters['auth/check']) {
    const { businessId } = router.currentRoute.params

    // 案件IDなし
    if (typeof businessId === 'undefined') {
      return params ? { name, params } : { name }
    }

    // 案件IDあり
    return withBusinessId(name, params, businessId)
  }

  // プランナー・パートナー
  if (store.getters['auth/isStaff']) {
    return withBusinessId(name, params, store.getters['auth/businessId'])
  }

  // 新郎新婦 or 施設
  return params ? { name, params } : { name }
}

function withBusinessId(name, params, businessId) {
  return {
    name: `business.${name}`,
    params: params ? Object.assign({}, params, { businessId }) : { businessId }
  }
}
